export default "__VITE_ASSET__Bf9u8OcF__"